/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Move_ToInputs */

const cs_pipelines_move_to = /** @type {(inputs: Pipelines_Move_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přesunout do`)
};

const en_pipelines_move_to = /** @type {(inputs: Pipelines_Move_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move to`)
};

/**
* | output |
* | --- |
* | "Move to" |
*
* @param {Pipelines_Move_ToInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_move_to = /** @type {((inputs?: Pipelines_Move_ToInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Move_ToInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_move_to(inputs)
	return cs_pipelines_move_to(inputs)
});